import { configureStore } from '@reduxjs/toolkit'
import zoneReducer from './slices/zoneSlice'
import authReducer from './slices/authSlice'

export const store = configureStore({
  reducer: {
    zones: zoneReducer,
    auth: authReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/checkAuth/pending'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
